import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCopy, faDownload, faPen, faSync, faTrashAlt, faTrashUndoAlt,
} from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import { confirmAction } from '@functions/entity'
import handleCallbackAction from '@functions/handleCallbackAction'

import useCampaignQuoteTemplate from '@hooks/useCampaignQuoteTemplate'

import {
  defaultRequestOptions,
} from '@components/QuoteBuilder/components/QuoteTemplateBuilder/hooks/useQuoteTemplateBuilder'

interface CampaignQuoteTemplateToolsProps {
  campaignQuoteTemplatePayload: ReturnType<typeof useCampaignQuoteTemplate>,
}

const CampaignQuoteTemplateTools = (props: CampaignQuoteTemplateToolsProps) => {
  const {
    campaignQuoteTemplatePayload: {
      callbacks: {
        createOrEditCampaignQuoteTemplate,
        downloadQuoteTemplate,
        duplicateCampaignQuoteTemplate: duplicateFn,
        recalculateQuoteTemplatePrices,
        toggleHideCampaignQuoteTemplate,
      },
      campaignQuoteTemplate: {
        hidden,
      },
      creating,
      updating,
    },
  } = props

  const confirmButtonColor = hidden ? '#43ac6a' : '#DD6B55'
  const actionString = hidden ? 'unarchive' : 'archive'

  const toggleHidePayload = {
    callbacks: {
      actionFn: toggleHideCampaignQuoteTemplate,
    },
    options: {
      icon: 'warning',
      confirmButtonColor,
    },
    strings: {
      actionString,
      entityName: 'quote template',
    },
  }

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faPen} />}
        onClick={() => createOrEditCampaignQuoteTemplate()}
        size="medium"
      >
        Edit Quote Details
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faSync} />}
        loading={updating}
        // @ts-expect-error TS2322
        marginTop="medium"
        onClick={() => recalculateQuoteTemplatePrices(defaultRequestOptions.campaignQuoteTemplate)}
        size="medium"
      >
        Recalculate Prices
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faDownload} />}
        loading={updating}
        // @ts-expect-error TS2322
        marginTop="medium"
        onClick={() => downloadQuoteTemplate()}
        size="medium"
      >
        Download Quote Template
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faCopy} />}
        loading={creating}
        // @ts-expect-error TS2322
        marginTop="medium"
        onClick={() => handleCallbackAction({
          callbacks: {
            // @ts-expect-error TS2322
            action: duplicateFn,
          },
          requestOptions: defaultRequestOptions.campaignQuoteTemplate,
          shouldRedirect: true,
          toastText: 'Quote Template Duplicated',
        })}
        size="medium"
      >
        Duplicate Template
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={hidden ? faTrashUndoAlt : faTrashAlt} />}
        loading={updating}
        // @ts-expect-error TS2322
        marginTop="medium"
        // @ts-expect-error TS2345
        onClick={() => confirmAction(toggleHidePayload)}
        size="medium"
      >
        {hidden ? 'Unarchive Template' : 'Archive Template'}
      </Button>
    </Tools>
  )
}

export default CampaignQuoteTemplateTools
